import { render, staticRenderFns } from "./JobRequestDetail.vue?vue&type=template&id=4f5170f9&scoped=true"
import script from "./JobRequestDetail.vue?vue&type=script&lang=js"
export * from "./JobRequestDetail.vue?vue&type=script&lang=js"
import style0 from "./JobRequestDetail.vue?vue&type=style&index=0&id=4f5170f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5170f9",
  null
  
)

export default component.exports